import PropTypes from "prop-types";

export const AccentRed = ({ children }) => {
  return <span style={{ color: "#dc0032" }}>{children}</span>;
};

AccentRed.propTypes = {
  children: PropTypes.node,
};
